// Copyright (c) 2026 Digital Asset (Switzerland) GmbH and/or its affiliates. All rights reserved.
// SPDX-License-Identifier: Apache-2.0
import { Holding } from '@daml.js/utility-registry-holding-v0/lib/Utility/Registry/Holding/V0/Holding';
import TemplateContract from './TemplateContract';

export const groupHoldings: (
  holdings: TemplateContract<Holding>[],
) => Record<string, Record<string, TemplateContract<Holding>[]>> = (holdings) => {
  return holdings.reduce(
    (acc, holding) => {
      const instrumentAdmin = holding.payload.instrument.source;
      const instrumentId = holding.payload.instrument.id;
      if (!acc[instrumentAdmin]) {
        acc[instrumentAdmin] = {};
      }

      if (!acc[instrumentAdmin][instrumentId]) {
        acc[instrumentAdmin][instrumentId] = [];
      }

      acc[instrumentAdmin][instrumentId] = [...acc[instrumentAdmin][instrumentId], holding];

      return acc;
    },
    {} as Record<string, Record<string, TemplateContract<Holding>[]>>,
  );
};
